import React, { Component } from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

export default styled(Link)(
  {
    fontFamily: "Avenir Next",
    transition: "opacity 150ms ease",
    fontSize: "15px",
    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  props => ({
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    color: props.color,
    fontWeight: props.fontWeight,
    textDecoration: props.border ? "border" : "none",
  })
)
